// extracted by mini-css-extract-plugin
export var callToActionButton = "menuItem-module--callToActionButton--36230";
export var callToActionContent = "menuItem-module--callToActionContent--2317c";
export var callToActionImage = "menuItem-module--callToActionImage--866f8";
export var genericContainer = "menuItem-module--genericContainer--6364f";
export var link = "menuItem-module--link--b6926";
export var linksContainer = "menuItem-module--linksContainer--a60af";
export var menuItem = "menuItem-module--menuItem--1a371";
export var sectionTitle = "menuItem-module--sectionTitle--0d68b";
export var sectionsContainer = "menuItem-module--sectionsContainer--d0001";
export var titleDivider = "menuItem-module--titleDivider--1c324";
export var viewAllLink = "menuItem-module--viewAllLink--d2851";